import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
import Pagination, { getStoredPageSize } from '../../components/Pagination/Pagination';
import Footer from '../../components/Footer/Footer';
import { processError } from '../../services/ServiceUtils';
import WithdrawTemplateRow from './WithdrawTemplateRow';
import WithdrawTemplateModal from './WithdrawTemplateModal/WithdrawTemplateModal';
import Toast from '../../components/Toast/Toast';
import NewWithdrawTemplateButton from './NewWithdrawTemplateButton';
import WithdrawSecurityPanel from './WithdrawSecurityPanel';
import ProfitRealizationPanel from './ProfitRealizationPanel';
import WithdrawSkimWizard from './WithdrawSkimWizard';
import { getWithdrawTemplates, deleteWithdrawTemplate } from '../../services/WithdrawTemplatesService';
import { doWithdraw } from '../../services/ExchangeService';
import { getEmptyMessage, getErrorMessage, getInfoMessage, getSuccessMessage } from '../../utils/MessageUtils';
import { isRunningLocalhost } from '../../utils/NetUtils';
import { findRowFromActionButton, getIdFromActionButton } from '../../utils/DataRowButtonUtils';

function WithdrawTemplates() {

    useEffect(() => {        
        if (isRunningLocalhost())
            setNotification(getInfoMessage('Estas funcionalidades só funcionam em produção.'));
    }, []);

    const defaultLocation = useLocation();

    const history = useHistory();

    function getPage(location) {
        if (!location) location = defaultLocation;
        return new URLSearchParams(location.search).get('page');
    }

    function getSize(location) {
        if (!location) location = defaultLocation;
        return parseInt(new URLSearchParams(location.search).get('size')) || getStoredPageSize();
    }

    useEffect(() => {
        return history.listen(location => {
            setPage(getPage(location));
            setSize(getSize(location));
        });
    }, [history]); // eslint-disable-line react-hooks/exhaustive-deps

    const [withdrawTemplates, setWithdrawTemplates] = useState([]);
    const [page, setPage] = useState(getPage());
    const [size, setSize] = useState(getSize());
    const [count, setCount] = useState(0);
    const [notification, setNotification] = useState(getEmptyMessage());

    const [editWithdrawTemplate, setEditWithdrawTemplate] = useState({});

    useEffect(() => {
        getWithdrawTemplates('', page || 1, size)
            .then(result => {
                setWithdrawTemplates(result.rows ? result.rows : []);
                setCount(result.count);
                setEditWithdrawTemplate(result.rows && result.rows.length > 0 ? result.rows[0] : {});
            })
            .catch(err => setNotification(getErrorMessage(processError(err))))
    }, [page, size]);

    function onEditClick(event) {
        setEditWithdrawTemplate(findRowFromActionButton(event, withdrawTemplates));
    }

    function onDeleteClick(event) {
        deleteWithdrawTemplate(getIdFromActionButton(event))
            .then(result => history.go(0))
            .catch(err => setNotification(getErrorMessage(processError(err))))
    }

    function onRunClick(event) {
        doWithdraw(getIdFromActionButton(event))
            .then(result => setNotification(getSuccessMessage(`Saque #${result.id} realizado com sucesso!`)))
            .catch(err => setNotification(getErrorMessage(processError(err))))
    }

    function onSubmit(event) {
        history.go(0);
    }

    return (
        <React.Fragment>
            <Menu />
            <main className='content'>
                <div className='d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4'>
                    <div className='d-block mb-4 mb-md-0'>
                        <h2 className='h4'>Modelos de Saque</h2>
                    </div>
                    <div className='btn-toolbar mb-2 mb-md-0'>
                        <div className='d-inline-flex align-items-center'>
                            <NewWithdrawTemplateButton />
                        </div>
                    </div>
                </div>
                <WithdrawSecurityPanel />
                <ProfitRealizationPanel />
                <div className='card card-body border-0 shadow mb-4 d-flex flex-row justify-content-between align-items-center flex-wrap'>
                    <div className='me-3'>
                        <h6 className='mb-1'>Automação de realização de lucro</h6>
                        <span className='text-muted small'>Monte em 1 passo: o bot saca uma fração do lucro novo e deixa o resto compondo.</span>
                    </div>
                    <button type='button' className='btn btn-primary' data-bs-toggle='modal' data-bs-target='#modalSkimWizard'>
                        Criar automação
                    </button>
                </div>
                <div className='card card-body border-0 shadow table-wrapper table-responsive'>
                    <table className='table table-hover'>
                        <thead>
                            <tr>
                                <th className='border-gray-200'>Moeda</th>
                                <th className='border-gray-200'>Nome</th>
                                <th className='border-gray-200'>Valor</th>
                                <th className='border-gray-200'>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                withdrawTemplates && withdrawTemplates.length
                                    ? withdrawTemplates.map(ot => (<WithdrawTemplateRow key={ot.id} data={ot} onEditClick={onEditClick} onDeleteClick={onDeleteClick} onRunClick={onRunClick} />))
                                    : <React.Fragment></React.Fragment>
                            }
                        </tbody>
                    </table>
                    <Pagination count={count} size={size} />
                </div>
                <Footer />
            </main>
            <WithdrawTemplateModal data={editWithdrawTemplate} onSubmit={onSubmit} />
            <WithdrawSkimWizard onSubmit={() => setNotification(getSuccessMessage('Automação de realização de lucro criada! Veja em Estratégias › Automações.'))} />
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    )
}

export default WithdrawTemplates;